import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { secureLink } from '@sparta.global.helpers/secure-link-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isSecureHost") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":20,"column":15}}})) != null ? stack1 : "")
    + "        </li>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"link") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":17,"column":10},"end":{"line":17,"column":58}}})) != null ? stack1 : "")
    + "\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row text-center large-collapse\">\r\n  <div class=\"row\">\r\n    <h3>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"manageAcct") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n    <div class=\"row\">\r\n      <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"manageAcct") : stack1)) != null ? lookupProperty(stack1,"intro") : stack1), depth0)) != null ? stack1 : "")
    + " </p>\r\n    </div>\r\n    <div class=\"manage-acc-btn\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"manageAcct") : stack1)) != null ? lookupProperty(stack1,"accLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":67}}})) != null ? stack1 : "")
    + "</div>\r\n  </div>\r\n  <div class=\"row links-container\">\r\n    <div class=\"row\">\r\n      <h4 class=\"top-text\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"manageAcct") : stack1)) != null ? lookupProperty(stack1,"topText") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n    </div>\r\n    <ul class=\"list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"manageAcct") : stack1)) != null ? lookupProperty(stack1,"applicationLink") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":6},"end":{"line":22,"column":15}}})) != null ? stack1 : "")
    + "    </ul>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/manage-acct-cc-module",
  "version": "1.0.1",
  "id": "manageAcctCcModule",
  "containerID": "creditCardsManageAcctCcModule",
  "moduleName": "credit-cards-manage-acct-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "manage-acct-cc-module",
  "data": {
    "options": {},
    "init": "CreditCardsManageAcctCcModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link,
        secureLink
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link,
    secureLink
  },
  "dependencies": {
    "@sparta.global.helpers/secure-link-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8"
  },
  "stores": []
};

class ManageAcctCcModule extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {}
}
registerModuleClass({
  moduleClass: ManageAcctCcModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ManageAcctCcModule as default, moduleConfig };
